<template>
  <div>
   <!-- toasts message -->
   <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
   <!-- /toasts message -->
   <!-- Form -->  
   <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text>          
        <v-container grid-list-md>
          <v-layout wrap> 

            <v-flex xs12 sm6 md4>                
              <DatePicker
              :key="formSchema.id"
              :inputData="{index:1,fieldName:'start_date', fieldValue:dateValue.start_date, label:'Start Date',required:'1'}"
              @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <DatePicker
              :key="formSchema.id"
              :inputData="{index:2,fieldName:'end_date', fieldValue:dateValue.end_date, label:'End Date',required:'1', disabled:'1'}"
              ref="setRange"
              @setValue="setDateValue"
              ></DatePicker>
            </v-flex> 

            <v-flex xs12 sm6 md4>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
                  <v-icon>save</v-icon>
                  {{addUpdateBtn}}
                </v-btn>

                <v-btn color="error" @click="previous">
                  <v-icon>arrow_back_ios</v-icon>Back
                </v-btn>          
              </v-card-actions>
            </v-flex>   

            <!-- _______________1st Table_______________ -->
            <v-flex xs12 sm12 md12>
              <div style="overflow: auto; white-space: nowrap;">
              <table class="BIPTable" width="100%">
                  <tbody>
                    <tr class="textCenter textBold">
                      <td rowspan="3">Economic Code</td>      
                      <td rowspan="3">Item</td>
                      <td colspan="5">Target 1st Quarter</td>
                      <td colspan="5">Target 2nd Quarter</td>
                      <td colspan="5">Target 3rd Quarter</td>
                      <td colspan="5">Target 4th Quarter</td>
                    </tr>
                    <tr class="textCenter textBold">
                      <td rowspan="2">Total</td>
                      <td rowspan="2">Taka</td>
                      <td colspan="2">Project help</td>
                      <td rowspan="2">Others</td>

                      <td rowspan="2">Total</td>
                      <td rowspan="2">Taka</td>
                      <td colspan="2">Project help</td>
                      <td rowspan="2">Others</td>

                      <td rowspan="2">Total</td>
                      <td rowspan="2">Taka</td>
                      <td colspan="2">Project help</td>
                      <td rowspan="2">Others</td>

                      <td rowspan="2">Total</td>
                      <td rowspan="2">Taka</td>
                      <td colspan="2">Project help</td>
                      <td rowspan="2">Others</td>  

                    </tr>
                    <tr class="textCenter textBold">
                      <td>DPA</td>
                      <td>RPA</td>
                      <td>DPA</td>
                      <td>RPA</td>
                      <td>DPA</td>
                      <td>RPA</td>
                      <td>DPA</td>
                      <td>RPA</td>
                    </tr>
                    <tr v-for="(val,index) in formSchema">
                      <td>
                        <v-text-field hide-details v-model="formSchema[index].eco_account_code" readonly></v-text-field>  

                         <input type="hidden" v-model="formSchema[index].eco_code_id" readonly/>
                      </td>
                      <td class="itemWidth">
                        <v-text-field hide-details v-model="formSchema[index].eco_account_name" readonly></v-text-field>
                      </td>

                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q1_total" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q1_taka" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q1_gpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q1_rpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q1_others" :rules="[decimalShort]"></v-text-field>
                      </td>


                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q2_total" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q2_taka" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q2_gpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q2_rpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q2_others" :rules="[decimalShort]"></v-text-field>
                      </td>


                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q3_total" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q3_taka" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q3_gpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q3_rpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q3_others" :rules="[decimalShort]"></v-text-field>
                      </td>

                      
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q4_total" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q4_taka" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q4_gpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q4_rpa" :rules="[decimalShort]"></v-text-field>
                      </td>
                      <td class="fldWidth">
                        <v-text-field hide-details v-model="formSchema[index].q4_others" :rules="[decimalShort]"></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </v-flex>
              <!-- _______________/1st Table_______________ -->

              

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>

          <v-btn color="error" @click="previous">
            <v-icon>arrow_back_ios</v-icon>Back
          </v-btn>          
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema", "dateValue"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,  
    documentFiles: [],
    BudgetingYearList: utilities.getBudgetingYearList(),
    itemLists:[
    'পণ্য  ও সেবার ব্যবহার',
    'প্রশাসনিক ব্যয়',
    'আপ্যায়ন ব্যয়',
    'আইন সংক্রান্ত ব্যয়',
    'সেমিনার/কনফারেন্স',
    'ইন্টারনেট/ফ্যাক্স/টেলেক্স',
    'ডাক',
    'প্রচার ও বিজ্ঞাপন',
    'আউটসোর্সিং',
    'নিরীক্ষা/সমীক্ষা ফি',
    ],

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "BIP Report Form" : "BIP Report Form";
    },
    addUpdateBtn() {
      return this.dateValue.id > 0 ? "Update" : "Save";
    }
  },

  created() {
      
  },

  methods: {
    setDateValue(data) {
      let index = data.index
      this.dateValue[data.fieldName] = data.value;

      if(data.fieldName == "start_date"){
        this.dateValue.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    SumValues(fieldName,totalFiel)
    {
      let A = this.formSchema.quater[0][fieldName];
      let B = this.formSchema.quater[1][fieldName];
      let Total = this.formSchema[totalFiel] = ((parseFloat(A) || 0) + (parseFloat(B)||0)).toFixed(3);
    },

    validateBeforeSubmit(e) {

      //let formData = new FormData();

      var formSchema = this.formSchema;

      var dateValue = this.dateValue;
      dateValue.start_date = this.changeFormateYMD(
        dateValue.start_date
        );

      dateValue.end_date = this.changeFormateYMD(
        dateValue.end_date
        );

      var formData = {"dateValue": dateValue, "formSchema": formSchema}
      

      //console.log('formSchema', formSchema);

      if (this.$refs.form.validate()) {     

        let func_name = 'insertFormData';
        if(dateValue.id>0)
        {
          func_name = 'updateFormData';
          formData.id = dateValue.id;
        }

        //console.log('formData', formData);
        //return 0;

        commonService[func_name](formData, "bip-report").then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: res.action,
            status: res.status
          };

          if (res.status == 1) {
            //this.$refs.form.reset();
            this.formSchema.id = 0;
            this.formSchema.start_date = ''
            this.formSchema.end_date = ''
          }
          this.close(actionData);
        });
      }
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.doc|\.docx|\.doc)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {

        this.SnackbarVal.message = "You can upload jpg, jpeg, png, pdf, doc and docx file only";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = 'error';

        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.documentFiles.push(uploadedFiles[i]);
        }
      }
    },
    
    previous:function()
    {
      //this.$refs.form.reset();
      this.$emit("emitForm", {'status':'back'});
    },

    close: function(data) {      
      //this.$refs.form.reset();
      this.$emit("emitForm", data);
    }
  }
};
</script>
<style scoped>
.v-text-field{
  padding-top: 0px !important;
}
table.BIPTable{
  border-collapse: collapse;
}
.BIPTable th,
.BIPTable tr td{
  border:1px solid #CCC !important;  
  line-height: 20px;
}
.BIPTable tr.textCenter,
.textCenter
{
  text-align: center;
}
.BIPTable tr.textBold,
.textBold{
  font-weight: bold;
}

</style>


// WEBPACK FOOTER //
// src/components/project_info/bip/insertForm.vue